import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventosService } from 'src/app/services/eventos.service';
import { SeguidoresService } from 'src/app/services/seguidores.service';
import { UserService } from 'src/app/services/user.service';
import { InfoConditionsComponent } from '../profile/info-conditions/info-conditions.component';
import { InfoCardComponent } from '../shared/info-card/info-card.component';
import { SubscriberFrontComponent } from '../subscriber-front/subscriber-front.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { BusinessService } from 'src/app/services/business.service';
import { PlacesService } from 'src/app/services/places.service';
import { BondsServices } from 'src/app/services/bonds.service';

@Component({
  selector: 'app-page-owner',
  templateUrl: './page-owner.component.html',
  styleUrls: ['./page-owner.component.scss']
})
export class PageOwnerComponent implements OnInit {

  urlImages: string = AppSettings.MEDIA_URI;
  isBusiness: boolean = false;
  eventosCerca: Observable<any[]>;
  results: boolean = true;

  owner: any = {};
  sharedSupported: boolean = false;

  user!: any;
  isWishlist: boolean = false;
  index: number = 0;
  teatroIdeal: boolean = false;
  activeTab: 'events' | 'abonos' = 'events';

  checkConditions: boolean = false;
  companyConditions: string = '';
  hasAbonos: boolean = false;

  get companyId(): number | null {
    if (this.isBusiness) return this.owner.id ?? null;
    return this.owner.id_company?.id ?? this.owner.id_company ?? null;
  }

  constructor(private titleService: Title, private activatedRoute: ActivatedRoute, private eventosService: EventosService,
    private userService: UserService, private router: Router, private dialog: MatDialog, private bussinessService: BusinessService,
    private placesService: PlacesService, private siguiendoService: SeguidoresService, private auth: AuthenticationService,
    private apiBusiness: ApiBusinessService, private bondsService: BondsServices) { }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(segments => {
      this.activeTab = segments.some(s => s.path === 'abonos') ? 'abonos' : 'events';
    });

    this.activatedRoute.params.subscribe(params => {
      let idOwner = params.idOwner;
      let pathUrl = params.pathUrl;
      this.isBusiness = location.href.indexOf('/events/') != -1 ? true : false;
      this.urlImages += this.isBusiness ? '/companies_images/' : '/spaces/';
      const idCity = sessionStorage.getItem('city') || 1;
      if (!idOwner && location.href.indexOf('teatroideal') != -1) {
        pathUrl = 'teatroideal';
        this.teatroIdeal = true;
      }
      if (this.isBusiness) {
        this.bussinessService.getInfoCompany(pathUrl).subscribe(data => {
          if (data.success) {
            this.owner = data.data;
            if (this.owner.general_conditions) {
              this.checkConditions = true;
            }
            this.titleService.setTitle('Citylok - ' + this.owner.name);
            this.checkHasAbonos(this.owner.id);
          }
        })
      }
      else {
        this.placesService.getInfoSpace(pathUrl).subscribe(data => {
          if (data.success) {
            this.owner = data.data;
            if (this.owner.general_conditions) {
              this.checkConditions = true;
            } else {
              const companyId = this.owner.id_company?.id ?? this.owner.id_company;
              if (companyId) {
                this.apiBusiness.getCompanyById(companyId).subscribe(res => {
                  if (res?.data?.general_conditions) {
                    this.companyConditions = res.data.general_conditions;
                    this.checkConditions = true;
                  }
                });
              }
            }
            this.titleService.setTitle('Citylok - ' + this.owner.name);
            this.checkHasAbonos(this.companyId);
          }
        })
      }

    });
    const navigator = window.navigator as any;
    if (navigator.share) {
      this.sharedSupported = true;
    }
  }

  setActiveTab(tab: 'events' | 'abonos') {
    // /teatroideal tiene ruta propia sin :pathUrl, así que no se puede construir
    // la URL como en el resto de espacios.
    if (this.teatroIdeal) {
      this.router.navigate(tab === 'abonos' ? ['teatroideal', 'abonos'] : ['teatroideal']);
      return;
    }
    const pathUrl = this.activatedRoute.snapshot.params['pathUrl'];
    const base = this.isBusiness ? 'events' : 'venue';
    if (tab === 'abonos') {
      this.router.navigate([base, pathUrl, 'abonos']);
    } else {
      this.router.navigate([base, pathUrl]);
    }
  }

  checkHasAbonos(companyId: number | null) {
    if (!companyId) return;
    this.bondsService.getPublicPassesByCompany(companyId).subscribe({
      next: (res) => {
        this.hasAbonos = (res?.passes?.length ?? 0) > 0;
      },
      error: () => { this.hasAbonos = false; }
    });
  }

  existsResults(exists: any) {
    this.results = exists;
  }

  changeTab(event: any) {
    this.index = event.index;
  }

  editSiguiendo() {
    this.isWishlist ? this.deleteFavorito() : this.addFavorito();
  }

  addFavorito() {
    if (this.user) {
      this.siguiendoService.postSiguiendo(this.owner.id).subscribe(res => {
        if (res) {
          this.isWishlist = true;
        }
      })
    } else {
      this.openInfoDialog('Inicia sesión y empieza a guardar tus favoritos');
    }
  }

  deleteFavorito() {
    if (this.user) {
      this.siguiendoService.deleteSiguiendo(this.owner.id).subscribe(res => {
        if (res) {
          this.isWishlist = false;
        }
      })
    } else {
      this.openInfoDialog('Inicia sesión y empieza a guardar tus favoritos');
    }
  }

  shareOwner() {
    if (this.sharedSupported) {
      const shareData = {
        title: this.owner.name,
        url: AppSettings.FRONT + '/events/' + this.owner.id + '/' + this.owner.name
      };
      navigator.share(shareData).catch((error) => {
        if (AppSettings.DEBUG) {
          console.error('Error sharing', error)
        }
      });
    }
  }

  openInfoDialog(msg: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: msg,
        btnCancel: false
      }
    });
  }

  openDialogConditions() {
    const text = this.isBusiness
      ? this.owner.general_conditions
      : (this.owner.general_conditions || this.companyConditions);
    this.dialog.open(InfoConditionsComponent, {
      panelClass: 'info-dialog',
      data: {
        text: text,
      }
    });
  }

}
